import courses from "../../data/courses";
// import * as net from "../../utils/network";
import api from '../../utils/api';
import {courseAddFailed} from "./courseActions";
import {NotificationManager} from 'react-notifications';
import * as VideoActions from './videoActions';
import * as ChapterPartActions from './chapterPartActions';

export const ACTION_GET_COURSES = 'ACTION_GET_COURSES';
export const ACTION_SHOW_MODAL_DELETE_PART = 'ACTION_SHOW_MODAL_DELETE_PART';
export const ACTION_DELETE_CHAPTER_PART = 'ACTION_DELETE_CHAPTER_PART';
export const ACTION_HIDE_MODAL_DELETE_PART = 'ACTION_HIDE_MODAL_DELETE_PART';
export const ACTION_EDIT_CHAPTER_INFORMATION = 'ACTION_EDIT_CHAPTER_INFORMATION';
export const ACTION_DELETE_ONE_CHAPTER = 'ACTION_DELETE_ONE_CHAPTER';
export const ACTION_ADD_NEW_CHAPTER = 'ACTION_ADD_NEW_CHAPTER';
export const ACTION_CHANGE_VISIBLE_COURSES = 'ACTION_CHANGE_VISIBLE_COURSES';
export const ACTION_DELETE_TEST_ASSIGNED = 'ACTION_DELETE_TEST_ASSIGNED';
export const ACTION_ADD_NEW_COURSE = 'ACTION_ADD_NEW_COURSE';
export const ACTION_SUBJECT_ADDED = 'ACTION_SUBJECT_ADDED';
export const ACTION_SUBJECT_DELETED = 'ACTION_SUBJECT_DELETED';
export const ACTION_DELETED_CHAPTER_FILE = 'ACTION_DELETED_CHAPTER_FILE';
export const SET_ACTIVE_COURSE = 'SET_ACTIVE_COURSE';
export const FAKE_UPDATE_SUBJECT = 'FAKE_UPDATE_SUBJECT';

export const ACTION_COURSE_ADDED = 'ACTION_COURSE_ADDED';
export const ACTION_SUBJECTS_RETRIEVED = 'ACTION_SUBJECTS_RETRIEVED';
export const ACTION_COURSE_RETRIEVED = 'ACTION_COURSE_RETRIEVED';
export const ACTION_COURSE_UPDATED = 'ACTION_COURSE_UPDATED';
export const ACTION_COURSE_DELETED = 'ACTION_COURSE_DELETED';


// Tests
export const ACTION_TEST_ADDED = 'ACTION_TEST_ADDED';
export const ACTION_TEST_DELETED = 'ACTION_TEST_DELETED';
export const ACTION_TEST_UPDATED = 'ACTION_TEST_UPDATED';
export const ACTION_TEST_RETRIEVED = 'ACTION_TEST_RETRIEVED';
export const CHAPTER_TEST_RETRIEVED = 'CHAPTER_TEST_RETRIEVED';

// Course Users
export const ACTION_APPROVED_REQUEST = 'ACTION_APPROVED_REQUEST';
export const ACTION_ADDED_COURSE_USER = 'ACTION_ADDED_COURSE_USER';
export const ACTION_REMOVED_COURSE_USER = 'ACTION_REMOVED_COURSE_USER';
export const ACTION_ADD_COURSE_USER_FAILED = 'ACTION_ADD_COURSE_USER_FAILED';
export const ACTION_GOT_INSTRUCTORS = 'ACTION_GOT_INSTRUCTORS';
export const ACTION_GOT_STUDENTS = 'ACTION_GOT_STUDENTS';
export const ACTION_STUDENT_UPDATED = 'ACTION_STUDENT_UPDATED';

// Events
export const EVENT_CREATED = 'EVENT_CREATED';
export const EVENT_DELETED = 'EVENT_DELETED';
export const EVENTS_REQUESTED = 'EVENTS_REQUESTED';
export const EVENTS_RETRIEVED = 'EVENTS_RETRIEVED';

// function actionCoursesLoaded(notifications) {
//     return {
//         type: ACTION_GET_COURSES,
//         payload: courses
//     };
// }
// CREATORS
// export function getCoursesForAdmin() {
//     return (dispatch, getState) => {
//         const {core} = getState();
//
//         net.aGet('')
//             .then(data => {
//                 dispatch(actionCoursesLoaded(data.filter((courses) => courses === core))); //or any other relevant condition
//             });
//     };
// }

export function setActiveCourse(course){
    return {
        type: SET_ACTIVE_COURSE,
        payload: course
    }
}

function subjectsRetrieved(subjects){
    return {
        type: ACTION_SUBJECTS_RETRIEVED,
        payload: courses
    };
}

function courseAdded(course){
    return {
        type: ACTION_COURSE_ADDED,
        payload: course
    }

}

export function getSubjectsForAdmin(courses, index) {
    return (dispatch) => {
        dispatch(subjectsRetrieved());
    }
}

function coursesRetrieved(courses){
    return {
        type: ACTION_COURSE_RETRIEVED,
        payload: courses
    }
}

export function reorderChapterParts(data, token){
    return dispatch => {
        api.reorderChapterParts(data, token, res => {

        })
    }
}

export function reorderChapters(data, token){
    return dispatch => {
        api.reorderChapters(data, token, res => {
        })
    }
}

function deletedChapterFile(id){
    return {
        type:ACTION_DELETED_CHAPTER_FILE,
        payload: id
    }
}

export function deleteChapterFile(id, token){
    return dispatch => {
        api.deleteChapterFile(id, token, res => {
            dispatch(deletedChapterFile(id));
        })
    }
}

export const getSingleCourse = (courseId, token) => {
    return dispatch => {
        api.getSingleCourse(courseId, token, res => {
            dispatch(setActiveCourse(res.data));
        })
    }
}

export const getVQ = (id, chapterId, subjectId, token) => {
    return dispatch => {
        api.getVQ(id, chapterId, subjectId, token, res => {
            dispatch({
                type: 'GOT_VQ_COUNT',
                payload: {
                    id, 
                    chapterId, 
                    subjectId, 
                    ...res.data
                }
            })
        })
    }
}

export const getQQ = (id, chapterId, subjectId, token) => {
    return dispatch => {
        api.getQQ(id, chapterId, subjectId, token, res => {
            dispatch({
                type: 'GOT_QQ_COUNT',
                payload: {
                    id, 
                    chapterId, 
                    subjectId, 
                    ...res.data
                }
            })
        })
    }
}

export const getSingleSubject = (courseId, token) => {
    return dispatch => {
        api.getSingleSubject(courseId, token, res => {
            dispatch({
                type: 'GOT_SINGLE_SUBJECT',
                payload: res.data
            });
        })
    }
}

export const getCourseUsersByCourseId = (courseId, token) => {
    return dispatch => {
        api.getCourseUsersByCourseId(courseId, token, res => {
            dispatch({
                type: 'GOT_COURSES_USERS',
                payload: res
            })
        })
    }
}

export function getCoursesForAdmin(uid, courseUsers, token){


    if(typeof(courseUsers) === "object") {
        courseUsers = courseUsers.filter(cu => cu.role === 'instructor' && cu.status === 'approved');
    }
    return (dispatch) => {

        api.getCourses(uid, null, (res) => {

            if(typeof(courseUsers) === "object") {
                api.getCoursesById(uid, courseUsers.map(c => c.courseId), token, res2 => {
                    const data = [];
                    if (res.data.length > 0) {

                        res.data.map(e => {
                            return data.push(e);
                        })
                    }

                    if (res2.data.length > 0) {
                        res2.data.map(r => {
                            return data.push(r);
                        })

                    }
                    dispatch(coursesRetrieved(data));
                });
            }else{
                dispatch(coursesRetrieved(res.data));
            }

        });
    }
}

export function showModalDeletePart(id) {
    return {
        type: ACTION_SHOW_MODAL_DELETE_PART,
        payload: id
    }
}

export function hideModalDeletePart() {
    return {type: ACTION_HIDE_MODAL_DELETE_PART}
}

export function deleteChapterPart(id) {
    return {
        type: ACTION_DELETE_CHAPTER_PART,
        payload: id
    };
}

export function editChapterInformation(chapter, courseId, subjectId, files, uid, cu, token) {

    return (dispatch) => {
        api.editSubjectChapter(chapter, courseId, subjectId, token, res => {
            if(res.status === 200){
                if(res.data.id){
                    files.map(f => {
                        return api.uploadChapterFile(f, res.data.id, token, r => {
                            
                        });
                    })
                }

                api.getCourses(uid, cu, token, (res) => {


                    dispatch(coursesRetrieved(res.data));
                });

            }
        })
    }


}

/*
function chapterAdded(courses){
    return {
        type: ACTION_ADD_NEW_CHAPTER,
        payload: courses
    }
}

*/

export function getPendingRequests(token){
    return dispatch => {
        api.getPendingRequests(token, res => {
            dispatch({
                type: 'GOT_PENDING',
                payload: res.data
            })
        })
    }
}

export function addChapter(chapter, courseId, subjectId, files, uid, cu, token) {

    return (dispatch) => {
        api.addSubjectChapter(chapter, courseId, subjectId, token, res => {
            if(res.status === 200){
                //dispatch(getCoursesForAdmin(uid, cu, token));
                dispatch({
                    type: 'ADDED_CHAPTER',
                    payload: res.data
                });


            }
        })
    }


}

function deletedChapter(id){
    return {
        type: ACTION_DELETE_ONE_CHAPTER,
        payload: id
    }
}


export function deleteChapter(id, token) {
    return dispatch => {
        api.deleteChapter(id, token, res => {
            if(res.status === 200){
                dispatch(deletedChapter(id));
                NotificationManager.success("The chapter has been removed", "Deleted chapter");
            }else{
                NotificationManager.error(`The server responded with a ${res.status} code`, "Failed to delete chapter");
            }
        })
    }


}

export function handleVisibleChange(id) {
    return {
        type: ACTION_CHANGE_VISIBLE_COURSES,
        payload: id
    }
}

export function deleteAssignedTest(id) {
    return {
        type: ACTION_DELETE_TEST_ASSIGNED,
        payload: id
    }
}

export function addNewCourse(course, token){
    course.settings = {
        student: {},
        instructor: {}
    }

    course.messageSettings = {}
    course.email = {
        student: "<p>Welcome student!</p>\n\n<p>We&#39;re so glad to have you on board.&nbsp; Please click the link below to set up an account and get started.</p>\n\n<p>{{access}}</p>\n\n<p>Again, thanks so much for being a part of this.</p>\n\n",
        instructor: "<p>Welcome instructor!</p>\n\n<p>We&#39;re so glad to have you on board.&nbsp; Please click the link below to set up an account and get started.</p>\n\n<p>{{access}}</p>\n\n<p>Again, thanks so much for being a part of this.</p>\n\n\n"
    }

    course.rules = {
        conditions: []
    }

    return (dispatch) => {

        api.addCourse(course, token, (res) => {

            if(res.status === 200){
                dispatch(courseAdded(res.data));
            }else{
                dispatch(courseAddFailed(res));
            }
        })
    }
}

function subjectAdded(subject){
    return {
        type: ACTION_SUBJECT_ADDED,
        payload: subject
    }
}

export function addNewSubject(subject, id, uid, token, socket, profileId){

    return (dispatch) => {

        api.addCourseSubject(subject, id, token, (res) => {

            if(res.status === 200){
                dispatch({
                    type: 'ADDED_SUBJECT',
                    payload: res.data.subject
                });

                // We also need to emit a method to update subjectOrder of course:
                dispatch({
                    type: 'UPDATE_COURSE',
                    payload: res.data.course
                })
                
                let thread = {
                    users: [profileId],
                    createdAt: new Date(),
                    status: 1,
                    subjectId: res.data.id,
                    lastActivity: new Date()
                }
                socket.send(JSON.stringify({
                  type: 'CREATE_THREAD',
                  thread: thread
                }))
            }else{
                dispatch(courseAddFailed(res));
            }
        })

    }
}

export function removeChapterPart(id, token){
    return (dispatch) => {
        api.removeChapterPart(id, token, res => {
            dispatch(deleteChapterPart(id));
        });
    }
}

// Tests
function addedTest(test){
    return {
        type: ACTION_TEST_ADDED,
        payload: test
    }
}

function updatedTest(test){
    return {
        type: ACTION_TEST_UPDATED,
        payload: test
    }
}

function deletedTest(id){
    return {
        type: ACTION_TEST_DELETED,
        payload: id
    }
}

function retrievedTests(tests){
    return {
        type: ACTION_TEST_RETRIEVED,
        payload: tests
    }
}

function updatedCourse(course){
    return {
        type: ACTION_COURSE_UPDATED,
        payload: course
    }
}

function deletedCourse(id){
    return {
        type: ACTION_COURSE_DELETED,
        payload: id
    }
}

function deletedSubject(id){
    return {
        type: ACTION_SUBJECT_DELETED,
        payload: id
    }
}

export function getTestsByUID(uid, token){
    return (dispatch) => {
        api.getTestsByUID(uid, token, res => {
            dispatch(retrievedTests(res.data));
        })
    }
}

export function getAllTests(courseId, token){
    return dispatch => {
        api.getAllTests(courseId, token, res => {
            dispatch({
                type: 'GOT_ALL_TESTS',
                payload: res.data
            })
        })
    }
}

export function deleteTest(id, token){
    return (dispatch) => {
        api.deleteTest(id, token, res => {
            dispatch(deletedTest(id));
        })
    }
}

export function getChart(courseId, view, length, token){
    return dispatch => {
        dispatch({
            type: 'CLEAR_CHART'
        });

        api.getChart(courseId, view, length, token, res => {
            if(res.data && res.status === 200){
                dispatch({
                    type: 'GOT_CHART',
                    payload: res.data
                });
            }else{
                dispatch({
                    type: 'CHART_ERROR',
                    payload: 'Could not display chart'
                })
            }
        })
    }
}

export function syncStudentsSubjectOrders(courseId, token) {
    NotificationManager.info('Syncing All Students...');
    return dispatch => {
        api.syncStudentsSubjectOrders(courseId, token, res => {
            NotificationManager.success('All Students Synced');
            
        })
    }
}


export function deleteCourseTest(id, token){
    return (dispatch) => {
        api.deleteCourseTest(id, token, res => {
            dispatch({
                type: 'DELETED_COURSE_TEST',
                payload: id
            });

            dispatch(ChapterPartActions.deleteCourseTest(id));
        })
    }
}

export function addTest(data, token){
    return (dispatch) => {
        api.addTest(data, token, res => {
            dispatch(addedTest(res.data));
        })
    }
}


export function updateTest(data, token){
    return (dispatch) => {
        api.updateTest(data, token, res => {
            dispatch(retrievedTests(res.data));
            if(!data.id){
                dispatch(ChapterPartActions.addToDiagnosticTests(res.data));
            }
            NotificationManager.success('Your diagnostic test has been saved');
        })
    }
}

export function updateCourses(courses, uid, cu, token){
    return dispatch => {
        courses.map(c => {
            api.updateCourse(c, uid, token, res => {
            })
        })

        dispatch(getCoursesForAdmin(uid, cu, token));
    }
}

export function updateCourse(course, uid, token){
    return (dispatch) => {
        api.updateCourse(course, uid, token, res=> {
            dispatch(updatedCourse(res.data));
        })
    }
}

export function deleteCourse(id, token){
    return (dispatch) => {
        api.deleteCourse(id, token, res => {
            dispatch(deletedCourse(id));
        })
    }
}

export function deleteSubject(id, token){
    return (dispatch) => {
        api.deleteSubject(id, token, res => {
            dispatch(deletedSubject(id));
            dispatch({
                type: 'UPDATE_COURSE',
                payload: res.data.course
            })
        })
    }
}

function approvedRequest(courseuser){
    return {
        type: ACTION_APPROVED_REQUEST,
        payload: courseuser
    }
}

export function approveRequest(id, token){
    return (dispatch) => {
        dispatch(approvedRequest(id));
        api.approveCourseUserRequest(id, token, res => {
            
        })
    }
}

function addedCourseUser(user){
    return {
        type: ACTION_ADDED_COURSE_USER,
        payload: user
    }
}

function failedToAddCourseUser(error){
    return {
        type: ACTION_ADD_COURSE_USER_FAILED,
        payload: error
    }
}

export function addCourseUser(courseUser, uid, token){
    return (dispatch) => {

        api.RegisterUser({
            email: courseUser.email,
            password: new Date().getTime().toString(),
            role: courseUser.role,
            courseRegistration: courseUser.courseId,
            invited: true,
            complete: false,
            status: 'approved',
            fb: {},
            google: {}
        }, (registered) => {

            if (registered.status == 200) {
                dispatch(getCoursesForAdmin(uid, []));
                if(courseUser.role == "instructor"){
                    dispatch(getInstructors(token));
                }else if(courseUser.role == "student"){
                    dispatch(getStudents(token));
                }
            }else{
                dispatch(failedToAddCourseUser({}))
            }
        });
    }
}

function removedCourseUser(id){
    return {
        type: ACTION_REMOVED_COURSE_USER,
        payload: id
    }
}

export function removeCourseUser(id, token){
    return (dispatch) => {
        dispatch(removedCourseUser(id));
        api.removeCourseUser(id, token, res => {
            
        });
    }
}

function createdEvent(event){
    return {
        type: EVENT_CREATED,
        payload: event
    }
}

function gotEvents(events){
    return {
        type: EVENTS_RETRIEVED,
        payload: events
    }
}

export function createEvent(event, uid, token){
    return (dispatch) => {
        api.createEvent(event, uid, token, res => {
            dispatch(createdEvent(res.data));
        })
    }
}

export function getEvents(uid, token){
    return (dispatch) => {
        api.getEvents(uid, token, res => {
            dispatch(gotEvents(res.data));
        });
    }
}

export function updateChapterStatus(id, status, token){
    return dispatch => {
        api.updateChapterStatus(id, status, token, res => {
        });
    }
}

export function updateChapterPartStatus(id, status, token){
    return dispatch => {
        api.updateChapterPartStatus(id, status, token, res => {
        });
    }
}

function retrievedInstructors(data){
    return {
        type: ACTION_GOT_INSTRUCTORS,
        payload: data
    }
}

function retrievedStudents(data){
    return {
        type: ACTION_GOT_STUDENTS,
        payload: data
    }
}

export function getInstructors(token){
    return dispatch => {
        api.getInstructors(token, res => {
            dispatch(retrievedInstructors(res.data));
        })
    }
}

export function getStudents(token){
    return dispatch => {
        api.getStudents(token, res => {
            dispatch(retrievedStudents(res.data));
        })
    }
}

function updatedStudent(student){
    return {
        type: ACTION_STUDENT_UPDATED,
        payload: student
    }
}

export function updateCourseUser(courseUser, token){
    return dispatch => {
        api.updateCourseUser(courseUser, token, res => {
            if(res.status === 200){
                if(courseUser.role == "student") {
                    NotificationManager.success('Student updated successfully.');
                }else {
                    NotificationManager.success('Instructor updated successfully.');
                }
                dispatch(updatedStudent(res.data))
            }
        })
    }
}

export function getStudentsByCourse(courseId, token, skip){
    return dispatch => {
        api.getStudentsByCourse(courseId, token, skip, res => {
            dispatch({
                type: ACTION_GOT_STUDENTS,
                payload: res.data,
                skip: skip
            });


        })
    }
}

export function findStudentsByCourse(where, courseId, token, skip){
    return dispatch => {
        api.findStudentsByCourse(where, courseId, token, skip, res => {
            dispatch({
                type: ACTION_GOT_STUDENTS,
                payload: res.data,
                skip: skip
            });


        })
    }
}

export function getTotalStudentCount(courseId, token){
    return dispatch => {
        api.getStudentCount(courseId, token, res => {
            dispatch({
                type: 'GOT_STUDENT_COUNT',
                payload: res.data.count
            })
        })
    }
}

export function createCourseUser(courseUser, token){
    return dispatch => {
        // Create and have api pull the weight
        api.createCourseUser(courseUser, token, res => {
            NotificationManager.success('User has been approved for course.', 'Success');
            if(courseUser.role == "instructor"){
                dispatch(getInstructors(token));
            }else if(courseUser.role == "student"){

                dispatch(getStudents(token));
            }

        });
    }
}

function subjectUpdated(subject){
    return {
        type: FAKE_UPDATE_SUBJECT,
        payload: subject
    }
}

export function fakeUpdateSubject(subject){
    return dispatch => {
        dispatch(subjectUpdated(subject));
    }
}

export function updateSubject(subject, token){
    return dispatch => {
        api.updateSubject(subject, token, res => {
            NotificationManager.success('Successfully updated subject');
            dispatch(subjectUpdated(res.data));
        })
    }
}

function retrievedChapterTest(test){
    return {
        type: CHAPTER_TEST_RETRIEVED,
        payload: test
    }
}


export function updateChapterTest(test, token){
    return (dispatch) => {
        NotificationManager.success('Saved test.');
        if(test.id){
            api.updateChapterTest(test, token, res => {
                dispatch(retrievedChapterTest(res.data));
            });
        }else{
            api.addChapterTest(test, token, res => {
                dispatch(retrievedChapterTest(res.data));
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/coursesActions.js